class Errors {

    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
        // console.table(this.errors);
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }


    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        if (errors)
            return this.errors = errors;
        return this.errors = {}
    }
    /**
     * add the object to  errors.
     *
     * @param {object} errors
     */
    add(error) {
        if (error)
            return this.errors =  [...this.errors,{error}];
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];
            return false;
        }

        return this.errors = {}
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        // if (this.errors.field != undefined)
        return this.errors.hasOwnProperty(field)
    }

    /**
     * Determine if we have any errors.
     */

    any() {
        return Object.keys(this.errors).length > 0;
    }

}

export default Errors;